<template>
  <!-- Avance del proyecto: real vs programado + PoC + desglose por grupo (real vs plan). -->
  <summary-card :title="$t('prm_dash_progress_title')" :mode="mode">
    <template #icon><b-icon pack="fas" icon="chart-line" size="is-small"></b-icon></template>
    <template #extra>
      <span v-if="mode" class="chips">
        <source-chip source="medic"></source-chip>
        <source-chip source="planif"></source-chip>
      </span>
    </template>

    <div class="prog-body">
      <div class="bars">
        <div class="bar-row">
          <span class="bar-label">{{ $t('prm_dash_progress_real') }}</span>
          <bar :value="current" :color="realColor"></bar>
          <span class="bar-val" :style="{ color: realColor }">{{ n(current) }} %</span>
        </div>
        <div class="bar-row">
          <span class="bar-label">{{ $t('prm_dash_progress_scheduled') }}</span>
          <bar :value="scheduled" color="#8fa8c8"></bar>
          <span class="bar-val muted">{{ n(scheduled) }} %</span>
        </div>
        <div class="bar-row">
          <span class="bar-label">{{ $t('prm_dash_kpi_poc') }}</span>
          <bar :value="pocPct" color="#3a6bc8"></bar>
          <span class="bar-val muted">{{ poc != null ? n(pocPct) + ' %' : '-' }}</span>
        </div>
      </div>

      <p class="caption">{{ $t('prm_dash_progress_dev') }}: {{ dev }} {{ $t('prm_dash_pp') }} · {{ $t('prm_dash_progress_dev_note') }}</p>

      <template v-if="groups.length">
        <div class="group-head">{{ $t('prm_dash_progress_by_group') }}</div>
        <div class="groups">
          <div v-for="(g, i) in groups" :key="i" class="grp-cell">
            <div class="grp-top">
              <span class="grp-name" v-tip="g.name">{{ g.name }}</span>
              <span class="grp-val muted">{{ n(g.current) }} % / {{ n(g.scheduled) }} %</span>
            </div>
            <bar :value="g.current" :color="groupColor(g)"></bar>
          </div>
        </div>
      </template>
    </div>
  </summary-card>
</template>

<script>
  import SummaryCard from '../summary/summary-card.vue'
  import SourceChip from '../summary/source-chip.vue'
  import Bar from './bar.vue'
  import { SEM, progressColor } from './dashboard-model'
  import { tip } from '../shared/tip'

  export default {
    name: 'PrmDashProgress',

    components: { SummaryCard, SourceChip, Bar },

    directives: { tip },

    props: {
      sources: { type: Object, default: () => ({}) },
      groups: { type: Array, default: () => [] },
      poc: { type: Number, default: null }, // PoC económico (fracción): coste incurrido / coste total
      mode: { type: Boolean, default: false },
    },

    computed: {
      real () { return Number((this.sources.progress || {}).real) || 0 }, // TKE no trabaja con progreso real. será siempre 0
      current () { return Number((this.sources.progress || {}).current) || 0 }, // TKE no trabaja con progres real. Aqui ellos denominan progreso real al avance normal. por eso leemos de current
      scheduled () { return Number((this.sources.progress || {}).scheduled) || 0 },
      realColor () { return SEM[progressColor(this.real, this.scheduled)] },
      pocPct () { return this.poc != null ? Number(this.poc) * 100 : 0 },
      dev () {
        const d = this.real - this.scheduled
        return `${d >= 0 ? '+' : ''}${d.toFixed(1)}`
      },
    },

    methods: {
      n (v) { return (Number(v) || 0).toFixed(1) },
      // Color de la barra del grupo por su semáforo de avance ('real' (o sea current) vs programado). TKE no tiene progreso real
      groupColor (g) { return SEM[progressColor(g.current, g.scheduled)] },
    },
  }
</script>

<style lang="scss" scoped>
  .chips { display: inline-flex; align-items: center; }
  .prog-body { padding: 10px; }
  .bars { display: flex; flex-direction: column; gap: 8px; }
  .bar-row { display: grid; grid-template-columns: 120px 1fr 96px; align-items: center; gap: 10px; }
  .bar-label { font-size: 11px; color: #3d5570; font-weight: 600; white-space: nowrap; }
  .bar-val { font-size: 11px; font-weight: 700; text-align: right; font-variant-numeric: tabular-nums; }
  .bar-val.muted { color: #6b7787; }

  .caption { margin: 10px 0; font-size: 10px; color: #9aa4b2; }
  .group-head {
    font-size: 9px; font-weight: 700; text-transform: uppercase; letter-spacing: .04em; color: #6b7787;
    margin: 4px 0 8px; padding-top: 8px; border-top: 1px solid #eef0f3;
  }

  // Grupos en rejilla (varios por fila) con scroll vertical si hay muchos.
  .groups {
    display: grid; grid-template-columns: repeat(auto-fit, minmax(240px, 1fr)); gap: 10px 16px;
    max-height: 230px; overflow-y: auto; padding-right: 4px;
  }
  .grp-cell { min-width: 0; }
  .grp-top { display: flex; align-items: baseline; justify-content: space-between; gap: 8px; margin-bottom: 4px; }
  .grp-name { font-size: 11px; color: #3d5570; font-weight: 600; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
  .grp-val { font-size: 10px; font-weight: 700; white-space: nowrap; font-variant-numeric: tabular-nums; }
  .grp-val.muted { color: #6b7787; }
</style>
